import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ProposalProduct } from '../../project/models/ProposalProduct';

export interface EquipmentEditState {
    areaCoverageValues?: Record<string, number>;
    unmodifiedProposalProduct?: ProposalProduct;
}

const initialState: EquipmentEditState = {
    areaCoverageValues: undefined,
    unmodifiedProposalProduct: undefined
}

export const equipmentEditSlice = createSlice({
    name: 'equipmentEdit',
    initialState,
    reducers: {
        setAreaCoverageValues: (state, action: PayloadAction<Record<string, number> >) => {
            state.areaCoverageValues = action.payload;
        },
        clearAreaCoverageValues: (state) => {
            state.areaCoverageValues = undefined;
        }
    }
})

export const { setAreaCoverageValues, clearAreaCoverageValues } = equipmentEditSlice.actions;
export default equipmentEditSlice.reducer;